import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	accountDetailsContainer: {
		boxSizing: 'border-box',
		paddingLeft: 50,
		paddingRight: 50,
	},
	container: {},
	defaultChildStyle: {
		boxSizing: 'border-box',
		padding: '0 30px',
	},
});
